import axios from 'axios'
import { GetProjectContentResponse } from '../../types/content'

export const getProjectContent = async (
  projectId: number
): Promise<GetProjectContentResponse | null> => {
  try {
    const backendUrl = process.env.REACT_APP_BACKEND

    if (!backendUrl) {
      console.error('REACT_APP_BACKEND environment variable is not defined')
      return null
    }

    const token = localStorage.getItem('@realize: accessToken')
    if (!token) {
      console.error('No authorization token found')
      return null
    }

    const response = await axios.get(`${backendUrl}/n8n/mavis/contents`, {
      params: {
        project_id: projectId
      },
      headers: {
        Authorization: `Bearer ${token}`
      }
    })

    return (response.data as unknown) as GetProjectContentResponse
  } catch (error) {
    console.error('Unexpected error:', error)
    return null
  }
}
